import { createAction, props } from '@ngrx/store';

import { type CanvasElementId } from '@blaze-runtime/engine-domain';

export const updateChartWorkflow = createAction(
  '[Charts] Update chart workflow',
  props<{ elementId: CanvasElementId }>(),
);
